import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/authcontext';

interface ProtectedRouteProps {
    requiredRole?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredRole }) => {
    const authContext = useContext(AuthContext);

    if (!authContext) {
        throw new Error('ProtectedRoute must be used within an AuthProvider');
    }

    const { isAuthenticated, authorities, loading } = authContext;

    if (loading) {
        return (
            <div className="loader-container">
                <div className="spinner"></div>
                <p>Loading, please wait...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/signup" replace />;
    }

    if (requiredRole && !authorities.includes(requiredRole)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;